import { USER } from "./action";

const initialState = {
  usersList: [],
  userCreated: {},
  selectedUser: {},
  userUpdated: {}
};

export default function settingsUserReducer(state = initialState, action) {
  switch (action.type) {
    case USER.list.success:
      return {
        ...state,
        usersList: action.data,
        userCreated: {},
        userUpdated: {}
      };
    case USER.create.success:
      return {
        ...state,
        userCreated: action.data
      };
    case USER.edit.success:
      return {
        ...state,
        selectedUser: action.data
      };
    case USER.update.success:
      return {
        ...state,
        userUpdated: action.data
      };
    case USER.disable.success:
      return {
        ...state
        //userUpdated: action.data
      };
    case USER.enable.success:
      return {
        ...state
        //userUpdated: action.data
      };
    case USER.delete.success:
      const userId = action.data.id;
      return {
        ...state,
        usersList: state.usersList.filter(user => user.id !== userId)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/users/reducer.js